import inlineStyles from 'juice';
import pipe from 'lodash/fp/pipe';
import sanitize from 'sanitize-html';
import { sanitizationProfiles } from './profiles';
import { channelToSanitizationProfile, removePlaceholderParagraphs, } from './utils';
export class SanitizeHTML {
    static sanitizerForProfile(profile) {
        return (html) => SanitizeHTML.byProfile(html, profile);
    }
    static sanitizerForChannel(channel) {
        return (html) => SanitizeHTML.byChannel(html, channel);
    }
    static byChannel(html, channel) {
        const profile = channelToSanitizationProfile[channel];
        return SanitizeHTML.sanitize(html, profile);
    }
    static byProfile(html, profile) {
        return SanitizeHTML.sanitize(html, profile);
    }
    static sanitize(html, profile) {
        const sanitizeHTML = (html) => sanitize(html, sanitizationProfiles[profile]);
        const inlineCSS = profile !== 'email' ? (identity) => identity : inlineStyles;
        return pipe(inlineCSS, sanitizeHTML, removePlaceholderParagraphs)(html);
    }
}
SanitizeHTML.profiles = sanitizationProfiles;
